import * as React from "react";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface FeatureCardSimpleProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  className?: string;
}

export function FeatureCardSimple({ icon, title, description, className }: FeatureCardSimpleProps) {
  return (
    <div className={cn(
      "shadow-soft bg-white hover:shadow-luxury transition-all rounded-lg p-6 text-center",
      className
    )}>
      {icon && <div className="mb-4">{icon}</div>}
      <h4 className="font-inter font-semibold text-foreground mb-3">{title}</h4>
      {description && <p className="font-inter text-muted-foreground text-sm">{description}</p>}
    </div>
  );
}

interface SimpleCardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function SimpleCard({ children, className, onClick }: SimpleCardProps) {
  return (
    <div 
      className={cn(
        "shadow-soft bg-white rounded-lg",
        onClick && "cursor-pointer hover:shadow-luxury transition-all",
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}